module.exports = __webpack_public_path__ + "img/detail_content.50a9e1ca.png";